import React, { Component } from 'react';
import { Container, Form, Row} from 'react-bootstrap';
import styled, { ThemeProvider } from 'styled-components';
import theme from '../../../../Config/Theme';

const Div = styled.div`
    background-color: white;
    color: black;
`

class Integration extends Component{

    render() {
        return (
            <ThemeProvider theme={theme}>
                <Div>
                    <Container>
                        <Form className="p-3">
                            
                            <div className="form-section">
                                <h4>Work / Home Balance / Integration</h4>
                                <hr />
                                <p className="font-italic font-weight-bold">
                                On a scale from 1 to 5 (1-Very Unsatisfied and
                                5-Very Satisfied...)
                                </p>

                                <Form.Group
                                as={Row}
                                name="formFlexibleWork"
                                controlId="formFlexibleWork"
                                onChange={this.props.handleChangeAsInt}
                                >
                                <Form.Label column sm={5}>
                                    30. How satisfied are you with your flexible work programs?
                                </Form.Label>
                                <Form.Check
                                    inline
                                    type="radio"
                                    label="1"
                                    value="1"
                                    name="formFlexibleWork"
                                    id="formFlexibleWork-1"
                                    defaultChecked={this.props.formFlexibleWork === 1}
                                />
                                <Form.Check
                                    inline
                                    type="radio"
                                    label="2"
                                    value="2"
                                    name="formFlexibleWork"
                                    id="formFlexibleWork-2"
                                    defaultChecked={this.props.formFlexibleWork === 2}
                                />
                                <Form.Check
                                    inline
                                    type="radio"
                                    label="3"
                                    value="3"
                                    name="formFlexibleWork"
                                    id="formFlexibleWork-3"
                                    defaultChecked={this.props.formFlexibleWork === 3}
                                />
                                <Form.Check
                                    inline
                                    type="radio"
                                    label="4"
                                    value="4"
                                    name="formFlexibleWork"
                                    id="formFlexibleWork-4"
                                    defaultChecked={this.props.formFlexibleWork === 4}
                                />
                                <Form.Check
                                    inline
                                    type="radio"
                                    label="5"
                                    value="5"
                                    name="formFlexibleWork"
                                    id="formFlexibleWork-5"
                                    defaultChecked={this.props.formFlexibleWork === 5}
                                />
                                </Form.Group>

                                <Form.Group className="ml-3" controlId="formFlexiblePrograms">
                                <Form.Label>
                                    31. What types of flexible programs are available to you?
                                </Form.Label>
                                <Form.Control
                                    name="formFlexiblePrograms"
                                    as="textarea"
                                    rows="4"
                                    onChange={this.props.handleChange}
                                    value={this.props.formFlexiblePrograms || ""}
                                />
                                </Form.Group>
                                
                            </div>
                        </Form>
                    </Container>
                </Div>
            </ThemeProvider>
        )
    }
}

export default Integration;